// Ödeme yöntemi başına alt/üst tutar sınırları — panel tarafı.
//
// Kayıt tek bir ayar alanındadır (`settings.payment_method_limits`) ve
// backend'deki karşılığı services/payment_limits.py'dir. Biçim ikisinde de
// aynı olmalıdır; ayrışırsa panelin yazdığı sınır istek yolunda hiç okunmaz
// ve arıza sessizdir: yönetici limiti girer, oyuncu eski aralığı görür.
//
//   { "<sağlayıcı>": { "<yön>": { "<yöntem kodu>": { min, max } } } }

// Yön adı iki yazımla dolaşıyor (`withdraw` / `withdrawal`); anahtar tek
// olmalı, yoksa aynı yöntem iki ayrı kayda yazılır.
export const normalizeDirection = (direction) => (
  String(direction || '').startsWith('with') ? 'withdrawal' : 'deposit'
);

const asTable = (limits) => (
  limits && typeof limits === 'object' && !Array.isArray(limits) ? limits : {}
);

/** Bir yöntemin kayıtlı sınırı; yoksa boş nesne. */
export const methodLimit = (limits, provider, direction, code) => {
  const entry = asTable(limits)[provider];
  const byDirection = asTable(entry)[normalizeDirection(direction)];
  const value = asTable(byDirection)[String(code)];
  return value && typeof value === 'object' ? value : {};
};

/**
 * Bir alanı yazar ve **yeni** bir tablo döndürür.
 *
 * Boşaltılan alan kayıttan tümüyle düşer: sıfır yazmak backend tarafında
 * "ayarlanmamış" sayılır ama kayıtta ölü bir satır bırakırdı. Yöntemin son
 * alanı da silinince yöntem, yön ve sağlayıcı kayıtları sırayla temizlenir —
 * aksi hâlde ayar boş sözlüklerle şişerdi.
 */
export const setMethodLimit = (limits, provider, direction, code, field, raw) => {
  const key = normalizeDirection(direction);
  const table = { ...asTable(limits) };
  const byProvider = { ...asTable(table[provider]) };
  const byDirection = { ...asTable(byProvider[key]) };
  const entry = { ...asTable(byDirection[String(code)]) };

  const value = Number(raw);
  if (raw === '' || raw === null || !Number.isFinite(value) || value <= 0) {
    delete entry[field];
  } else {
    entry[field] = value;
  }

  if (Object.keys(entry).length) {
    byDirection[String(code)] = entry;
  } else {
    delete byDirection[String(code)];
  }
  if (Object.keys(byDirection).length) {
    byProvider[key] = byDirection;
  } else {
    delete byProvider[key];
  }
  if (Object.keys(byProvider).length) {
    table[provider] = byProvider;
  } else {
    delete table[provider];
  }
  return table;
};

/** Alanın kutuya yazılacak hâli: kayıt yoksa boş bırakılır. */
export const limitFieldValue = (limits, provider, direction, code, field) => {
  const value = methodLimit(limits, provider, direction, code)[field];
  return value === undefined || value === null ? '' : String(value);
};

/**
 * Bu yönde herhangi bir yöntemin kendi tutarı var mı?
 *
 * Varsa ortak tutar alanı **kilitlenir**: iki yerden yönetilen tek bir sayı,
 * yöneticinin üstte yazdığı değerin neden hiçbir şeyi değiştirmediğini
 * açıklamayan bir arıza üretir.
 */
export const directionHasCustom = (limits, provider, direction) => {
  const byProvider = asTable(asTable(limits)[provider]);
  const byDirection = asTable(byProvider[normalizeDirection(direction)]);
  return Object.keys(byDirection).length > 0;
};

/** Bir yönün bütün yöntem tutarlarını siler; ortak tutara dönüş budur. */
export const clearDirectionLimits = (limits, provider, direction) => {
  const table = { ...asTable(limits) };
  const byProvider = { ...asTable(table[provider]) };
  delete byProvider[normalizeDirection(direction)];
  if (Object.keys(byProvider).length) {
    table[provider] = byProvider;
  } else {
    delete table[provider];
  }
  return table;
};

/** Yöntemin kendi sınırı var mı — rozet bunu gösterir. */
export const hasMethodLimit = (limits, provider, direction, code) => (
  Object.keys(methodLimit(limits, provider, direction, code)).length > 0
);
